import React from 'react';
import PropTypes from 'prop-types';
import { StyledScrollBox } from './components/ScrollBoxStyles';

const ScrollBox = ({ children, height, className }) => {
  return (
    <StyledScrollBox height={height} className={className}>
      {children}
    </StyledScrollBox>
  );
};

ScrollBox.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

ScrollBox.defaultProps = {
  height: undefined,
  className: '',
};

export default ScrollBox;



// WEBPACK FOOTER //
// ./src/design-system/atoms/ScrollBox/ScrollBox.jsx